<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}" (click)="scrollToTop()">
    <img src="assets/icons/arrow-right.svg" alt="arrow-right">
</div>
